import { useMemo } from "react";
import {
  CarService,
  DataService,
  MetaService,
  OrderService,
  ProductService,
  RouterService,
  LocationService,
  UserService,
  ValidationService,
  ServiceService,
  MicroServiceService,
  DashboardWidgetService,
  MiscService,
  LocaleService,
} from "../service";

const services: any = {
  Car: CarService,
  Data: DataService,
  Meta: MetaService,
  Order: OrderService,
  Product: ProductService,
  Router: RouterService,
  Location: LocationService,
  User: UserService,
  Validation: ValidationService,
  Service: ServiceService,
  MicroService: MicroServiceService,
  DashboardWidget: DashboardWidgetService,
  Misc: MiscService,
  Locale: LocaleService,
};

export const useService = (service: string, model?: string) => {
  return useMemo(() => new services[service](model), [service, model]);
};
